import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ScoreForm from '../../../components/forms/ScoreForm';
import { useScoreApi } from '../../../hooks/useScoreApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ScoreDTO } from '../../../services/apiClient';
import { ScoreTypeConstants } from '../../../constants/ScoreTypeConstants';
import EvaluationScoreForm from '../../../components/forms/EvaluationScoreForm';
import CompetitionScoreForm from '../../../components/forms/CompetitionScoreForm';

const ScoreEdit: React.FC = () => {
  const { getById, edit } = useScoreApi();
  const [entityData, setEntityData] = useState<ScoreDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Scores', href: '/admin/scores' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Score data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating Score:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  const renderForm = () => {
    if (!entityData) {
      return <p>Loading...</p>;
    }

    if (entityData.scoreTypeId === ScoreTypeConstants.COURSE_PRACTICAL_EVALUATION) {
      if (!entityData.course) {
        return <p>Error: Course data is required for evaluation scores.</p>;
      }
      
      return (
        <EvaluationScoreForm
          initialValues={entityData}
          course={entityData.course}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      );
    }

    if (entityData.scoreTypeId === ScoreTypeConstants.COMPETITION) {
      return (
        <CompetitionScoreForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      );
    }

    // Default to ScoreForm for IN_HOUSE and other types
    return (
      <ScoreForm
        initialValues={entityData}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        isLoading={isSubmitting}
      />
    );
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/scores"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin','User']}
      requiredPermission='Manage.Score.Edit'
    >
        {entityData ? (
          renderForm()
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ScoreEdit;